// extracted by mini-css-extract-plugin
export default {"container":"UM-z","topReviewHeading":"VM-z","criticalReview":"WM-z","favorableReview":"XM-z","vsSeparator":"YM-z"};